import React, { useEffect } from "react";
import { ProjectList } from "../../../data/ProjectData";
import "./ProjectCard.css"; // We'll update this CSS file

function ProjectCard() {
  useEffect(() => {
    // Initialize the intersection observer for animations
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Add a slight delay based on the index to create a staggered effect
          setTimeout(() => {
            entry.target.classList.add('visible');
          }, parseInt(entry.target.dataset.delay) || 0);
        }
      });
    }, {
      root: null,
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });
    
    // Observe all project cards
    document.querySelectorAll('.project-card').forEach(card => {
      observer.observe(card);
    });
    
    // Cleanup
    return () => {
      observer.disconnect();
    };
  }, []);

  // Direction options for entrance animations
  const directions = ['from-left', 'from-right', 'from-bottom', 'from-top'];

  return (
    <div className="projects-container">
      {ProjectList.map((project, index) => {
        // Assign a different direction to each card in rotation
        const direction = directions[index % directions.length];
        
        return (
          <div 
            className={`project-card ${direction}`}
            key={index}
            data-delay={index * 150}
          >
            <div className="project-card-inner">
              <div className="project-image">
                <div className="image-overlay"></div>
                <img 
                  src={project.img} 
                  alt={`${project.title} project`} 
                  className="project-thumbnail"
                />
              </div>
              
              <div className="project-content">
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>
                
                <div className="tech-stack">
                  {project.tech_stack.map((tech, techIndex) => (
                    <span className="tech-tag" key={techIndex}>{tech}</span>
                  ))}
                </div>
                
                <div className="project-links">
                  {project.github_url.length > 0 && (
                    <a
                      className="github-link"
                      href={project.github_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`View ${project.title} source code on GitHub`}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>
                      </svg>
                      <span>Code</span>
                    </a>
                  )}
                  
                  {project.demo_url.length > 0 && (
                    <a
                      className="demo-link"
                      href={project.demo_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`View ${project.title} live demo`}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                        <polyline points="15 3 21 3 21 9"></polyline>
                        <line x1="10" y1="14" x2="21" y2="3"></line>
                      </svg>
                      <span>Live Demo</span>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default ProjectCard;